/**
 * @generated SignedSource<<6bd82017fa0e9f986344d84f0dac1387>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksContentInterestArticle$data = {
  readonly entityId: string;
  readonly sentiment: unknown | null;
  readonly topics: ReadonlyArray<{
    readonly name: string;
  } | null> | null;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null> | null;
  } | null> | null;
  readonly urlAlias: string;
  readonly " $fragmentType": "hooksContentInterestArticle";
};
export type hooksContentInterestArticle$key = {
  readonly " $data"?: hooksContentInterestArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksContentInterestArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksContentInterestArticle"
};

(node as any).hash = "7e41a29c62eb7a0467f234077b14d019";

export default node;
